import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { api } from '../lib/api'
import { useAuth } from '../auth/AuthContext'
import Loading from '../ui/Loading'
import PublicFooter from '../ui/PublicFooter'

function sanitizeNext(next) {
    if (!next) return '/'
    const s = String(next).trim()
    // open redirect 방지: 앱에서 넘기는 값은 "상대경로(/...)"만 허용
    if (!s.startsWith('/')) return '/'
    if (s.startsWith('//')) return '/'
    if (s.includes('://')) return '/'
    return s
}

export default function AuthBridgePage() {
    const location = useLocation()
    const navigate = useNavigate()
    const { loginWithTokens } = useAuth()

    const [error, setError] = React.useState(null)
    const [loading, setLoading] = React.useState(true)

    React.useEffect(() => {
        let cancelled = false
        ; (async () => {
            setError(null)
            setLoading(true)
            try {
                const sp = new URLSearchParams(location.search || '')
                const code = sp.get('code')
                const next = sanitizeNext(sp.get('next'))
                if (!code) throw new Error('missing_code')

                const res = await api.post('/web-bridge/exchange', { code })
                const payload = (res?.data && res.data.data) ? res.data.data : res.data
                const accessToken = payload?.accessToken
                const refreshToken = payload?.refreshToken
                if (!accessToken || !refreshToken) throw new Error('invalid_exchange_response')

                await loginWithTokens({ accessToken, refreshToken })
                if (!cancelled) navigate(next, { replace: true })
            } catch (e) {
                if (!cancelled) setError(e)
            } finally {
                if (!cancelled) setLoading(false)
            }
        })()
        return () => { cancelled = true }
    }, [location.search, navigate, loginWithTokens])

    return (
        <div className="min-h-screen flex flex-col">
            <main className="flex-1 flex items-center justify-center px-4 py-12">
                <div className="w-full max-w-md">
                    <h1 className="text-xl font-bold mb-2">로그인 연결 중…</h1>
                    <p className="text-sm text-slate-600 mb-6">앱 로그인 정보를 기반으로 웹 로그인을 진행하고 있습니다.</p>
                    {loading && <Loading />}
                    {!loading && error && (
                        <div className="rounded-lg border border-rose-200 bg-rose-50 p-4 text-rose-700">
                            <div className="font-semibold mb-1">웹 자동 로그인을 완료할 수 없습니다.</div>
                            <div className="text-sm">코드가 만료되었거나 이미 사용된 코드일 수 있습니다. 다시 시도해 주세요.</div>
                            <div className="mt-3">
                                <button
                                    className="px-3 py-2 rounded bg-slate-900 text-white text-sm"
                                    onClick={() => navigate('/login', { replace: true })}
                                >
                                    로그인 화면으로 이동
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </main>
            <PublicFooter />
        </div>
    )
}

